module.exports = __webpack_public_path__ + "img/i_key_03.9ebc8bdf.svg";